import Swal from "sweetalert2";
import { Cart, CartSettings } from "../../libs/ts/cart";
import { Checkout } from "../../libs/ts/checkout";
import { Api, Menu, User } from "../../libs/ts/api";
import { HandlebarsRender } from "../../libs/ts/handlebars";
import dayjs from "dayjs";
import { events } from "../../libs/ts/events";
import { openLoading, closeLoading, loadingPage } from "../../libs/ts/swal";
// Verificar versión de clkec únicamente en /cart/ y limpiar todo si cambió
(function checkClkecVersion() {
    try {
        if (typeof window !== 'undefined' && window.location && window.location.pathname.startsWith('/cart/')) {
            const currentVersion = window.CLKEC_VERSION;
            if (currentVersion) {
                const storedVersion = localStorage.getItem('clkv');
                if (storedVersion && storedVersion !== currentVersion) {
                    localStorage.clear();
                }
                localStorage.setItem('clkv', currentVersion);
            }
        }
    }
    catch (e) {
        console.error('Error al verificar la versión de clkec:', e);
    }
})();
import { cartAddErrorCallback, cartAddSuccessCallback, userProfileUpdated, userProfileSendActivation, sendOrder, userProfileUpdatedError } from "../../libs/ts/swal";
import { registerAddProduct } from "../../libs/ts/cart-utils";
import { registerAutoComplete } from "../../libs/ts/autocomplete";
import { SetCurrency, GetCurrency, render_sidebar_items, render_actives_items, registerJsFilters, setCookie, getCookie, query, render_items, SetLoc, GetLoc, SetWar, GetWar, formatAmount, GetLang, SetLang, Plugin, onFinishLoadProducts, fetchError, TIMEOUT, clkecFetch } from "../../libs/ts/utils";
export const FetchError = function (value) {
    return fetchError(value);
};
export const Timeout = TIMEOUT;
export let ev = events;
export let DayJS = dayjs;
export let plugins = [];
export const getFormJSON = (form) => {
    const data = new FormData(form);
    return Array.from(data.keys()).reduce((result, key) => {
        result[key] = data.get(key);
        return result;
    }, {});
};
export const swal = Swal;
export const ApiClient = new Api(String(window.API_URL), "/api/menus/");
let settings = new CartSettings("js-cart-indicator-display", "text-primary", ".js-qty-display", ".js-total-display", ".js-subtotal-display", ".js-discount-display", ".js-taxes-display", ".js-headerdetail", ".js-footerdetail", cartAddSuccessCallback, cartAddErrorCallback, ApiClient);
export const createNewCart = (value) => {
    return Cart.getOrCreateCart(value, settings);
};
export const cart = Cart.getOrCreateCart(`${window.key_ec}CART`, settings);
export const checkout = Checkout.getOrCreateCheckout(`${window.key_ec}CHECKOUT`, ApiClient);
export const RenderSidebar = (sidebar, filters) => {
    return render_sidebar_items(sidebar);
};
export const RenderActives = (actives, filters) => {
    return render_actives_items(actives);
};
export const RegisterJsFilters = () => { registerJsFilters(cart); };
export const PromosRender = (values) => {
    let render = new HandlebarsRender('#promo-item-template', '#promoItemsContainer');
    render.render(values);
};
export const TopSellersRender = (values) => {
    let render = new HandlebarsRender('#product-item-template', '#topSellersItemsContainer');
    render.render(values);
};
export const menu = Menu.createEmptyMenu("#menu-template", "#navbarHeader", '#tpl-mobile-menu', "#modalSlider", "#menuSubmenu-template", "#navbarSubmenuHeader", 1, ApiClient);
export const user = User.createUser("#login-indicator-template", "#login-container", ApiClient);
export const swalAlerts = {
    "userProfileUpdated": userProfileUpdated,
    "userProfileUpdatedError": userProfileUpdatedError,
    "userProfileSendActivation": userProfileSendActivation
};
export const registerAddProductBtns = () => { registerAddProduct(cart); };
export const SectionRender = (section_slug, container, callback) => {
    ApiClient.loadSection(section_slug).then(html => {
        document.querySelector(container).innerHTML = html;
        callback === null || callback === void 0 ? void 0 : callback.call(html);
    });
};
export const registerAutoCompleteInput = (el) => { registerAutoComplete(el, ApiClient); };
export const Query = (cart, params, preload = false, updateUrl = true) => {
    // console.log('QUERYQUERY')
    // BannerRender('#banners');
    query(cart, params, preload, updateUrl);
};
export const BannerRender = (container) => {
    ApiClient.bannerRender(container);
};
export const GetVariant = (variant_id) => {
    return ApiClient.fetchVariant(variant_id);
};
export const GetVariantBase = (variant_id) => {
    return ApiClient.fetchVariantBase(variant_id);
};
export const RegisterPlugin = function (value, op = null) {
    plugins.push(new Plugin(value, op));
};
export const RenderItems = (cart, items, filters = new URLSearchParams(), options = { append: false }) => {
    render_items(cart, items, filters, options);
};
export const SDW = function (value) {
    const cv = GetWar();
    console.debug('SDW', cv);
    if (!cv || cv == '') {
        console.debug('SDW', 'set', value);
        SetWar(value);
    }
};
export const SetNewCurrency = function (value) {
    SetCurrency(value);
};
export const SetNewWar = function (value) {
    SetWar(value);
};
export const SetNewLoc = function (value) {
    SetLoc(value);
};
export const GetCurrentCurrency = function () {
    return GetCurrency();
};
export const GetCurrentLoc = function () {
    return GetLoc();
};
export const GetCurrentWar = function () {
    return GetWar();
};
export const FormatAmount = function (value, dp = 0) {
    return formatAmount(value, dp);
};
export const SDC = function (value) {
    const pc = GetCurrency();
    console.debug('SDC', pc);
    if (!pc || pc == '') {
        console.debug('SDC', 'set', value);
        SetCurrency(value);
    }
    else {
        SetCurrency(pc);
    }
};
export const SendOrder = function () {
    sendOrder();
};
export const SetLanguage = function (value) {
    SetLang(value);
};
export const GetLanguage = function () {
    return GetLang();
};
export const OnFinishLoadProducts = function () {
    onFinishLoadProducts(cart);
};
export const SetCookie = function (name, value, days = 1) {
    return setCookie(name, value, days);
};
export const GetCookie = function (name) {
    return getCookie(name);
};
export const OpenLoading = function () { openLoading(); };
export const CloseLoading = function () { closeLoading(); };
export const LoadingPage = function () { loadingPage(); };
export const Fetch = function (url, options) {
    return clkecFetch(url, options);
};
export const refreshBootstrap = function () {
    var tooltips = document.querySelectorAll('[data-toggle="tooltip"]');
    tooltips.forEach(function (tooltip) {
        try {
            new window.bootstrap.Tooltip(tooltip);
        }
        catch (e) { }
    });
};
export let fakemenu_items = [];
export const addToFakeMenu = async (item) => {
    fakemenu_items.push(item);
};
